import { DealerCheckbox } from '@api/types';
import { LoadingSkeleton, useDealerDetailsContext } from '@components';
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
} from '@mui/material';
import { colors } from '@themes/colors';

type DealerCheckboxGroupProps = {
  label: string;
  checkedItemList?: DealerCheckbox[];
  type: 'brands' | 'shopTypes';
  itemList?: DealerCheckbox[];
  isItemListWorking?: boolean;
};

export const DealerCheckboxGroup = ({
  label,
  checkedItemList,
  itemList,
  isItemListWorking,
  type,
}: DealerCheckboxGroupProps) => {
  const { canEditData, form } = useDealerDetailsContext();
  const canDisplay = canEditData || (checkedItemList?.length && itemList?.length);

  if (isItemListWorking) {
    return <CheckboxGroupSkeleton />;
  }

  return canDisplay ? (
    <FormGroup sx={{ mt: 1 }}>
      <FormLabel component='legend'>{label}</FormLabel>
      {itemList?.map((item, itemIndex) => {
        const isChecked = checkedItemList?.some((search) => search.id === item.id);
        return canEditData ? (
          <FormControlLabel
            sx={{ width: 'fit-content' }}
            key={itemIndex}
            control={
              <Checkbox {...form.register(`${type}`)} defaultChecked={isChecked} value={item.id} />
            }
            label={item.label}
          />
        ) : isChecked ? (
          <FormHelperText
            component='li'
            key={itemIndex}
            sx={{ my: 1, ml: 2, color: colors.text.primary, fontSize: 16 }}
          >
            {item.label}
          </FormHelperText>
        ) : null;
      })}
    </FormGroup>
  ) : null;
};

const CheckboxGroupSkeleton = () => {
  return (
    <Box sx={{ mt: 1 }}>
      <LoadingSkeleton variant='text' height={30} sx={{ mt: 2 }} />
      <LoadingSkeleton variant='text' height={30} sx={{ mt: 2 }} />
      <LoadingSkeleton variant='text' height={30} sx={{ mt: 2 }} />
    </Box>
  );
};
